<template>
    <div class="base-bg">
      <div class="nav-bar">
        <div class="btn-wrapper">
          <blue-btn info="返回" v-bind:handle-click="cancel"></blue-btn>
        </div>
      </div>
      <div class="content-block">
        <div class="desc-block img-block">
          <p>班级出勤人数图片</p>
          <div class="images">
            <div class="overflow">
              <card-view>
                <div slot="content">
                    <el-upload
                      class="upload-demo"
                      :action="url"
                      :on-remove="handleRemove"
                      :before-upload="beforeUpload"
                      :file-list="fileList"
                      :on-change="handleChange"
                      :accept="'.jpg,.jpeg,.png,.bmp'"
                      :headers="headers"
                      multiple
                      list-type="picture">
                      <el-button size="mini" type="primary">点击上传</el-button>
                    </el-upload>
                </div>
              </card-view>
            </div>
            <div class="btn-wrapper2">
                <blue-btn info="提交" v-bind:handle-click="submits"></blue-btn>
            </div>
          </div>
        </div>
      </div>
  
  
    </div>
  </template>
  <script>
    import BlueBtn from '../components/BlueBtn.vue';
    import CardView from '../components/CardView.vue';
    import { Toast } from 'mint-ui';
    import * as faceapi from 'face-api.js';
    import axios from '../api/axios';
    import store from '../store';
    import {studentImageList,list} from '../utils/studentImageLsit'
    import { mapGetters } from 'vuex';
    // var config =
    import config from '../../config'
    export default{
      name: 'UpImage',
      data () {
        return {
          dialogImageUrl:'',
          dialogVisible:false,
          fileList:[], //存储回显的照片
          url:process.env.NODE_ENV == 'production' ? config.build.baseUrl+'/api/qinius' : config.dev.baseUrl+'/api/qinius',
          headers:{
            'token':store.state.userInfo.user.token
          },
        };
      },
      components: {BlueBtn, CardView},
      created() {
        //回显上传的图片
        if(Object.keys(this.$store.state.teacherschools.listStudents.userImage).length !== 0){
          //只用作回显
          this.fileList = this.$store.state.teacherschools.listStudents.userImage;
        }
      },
      mounted(){
          // Promise.all([
          //   faceapi.nets.ssdMobilenetv1.loadFromUri('/models'), // 加载 SSD Mobilenet V1 模型
          //   faceapi.nets.faceLandmark68Net.loadFromUri('/models'), // 加载人脸关键点模型
          //   faceapi.nets.faceRecognitionNet.loadFromUri('/models') // 加载人脸识别模型
          // ]).then(() => {
          //   console.log('Models loaded');
          // });
        },
      methods: {
        //上传文件改变，就触发添加展示列表
        handleChange(file, fileList) {
          this.fileList = fileList;
        },
          //上传前-钩子
        beforeUpload(file){
          const fileName = file.name;
          const fileType = fileName.substring(fileName.lastIndexOf('.'));
          const isOKType =
          fileType === '.jpg' ||
          fileType === '.png' ||
          fileType === '.jpeg' ||
          fileType === '.bmp';
          const isLt2M = file.size / 1024 / 1024 < 10;
          if (!isOKType) {
            Toast({message: '图片格式只能为jpeg/png/jpg/bmp', position: 'middle', duration: 2000});
            return false;
          }
          else if (!isLt2M) {
            Toast({message: '图片大小不能超过 10MB!', position: 'middle', duration: 2000});
            return false;
          }
          // else{

          //  加载人脸检测模型
            // await faceapi.loadSsdMobilenetv1Model('/models');
            // await faceapi.loadFaceLandmarkModel('/models');
            // 加载图片并检测人脸
            // const img = await faceapi.fetchImage(URL.createObjectURL(file));
            // const detections = await faceapi.detectAllFaces(img);//检测图像中所有的人脸
            //                       // faceapi.detectSingleFace(img)//检测图像中置信最高的人脸
            // if (detections.length === 0) {
            //   Toast({message: '请选择有人脸的图片！', position: 'middle', duration: 3000});
            //   return false; // 阻止上传
            // } else {
            //   return true; // 允许上传
            // }
            // 检查文件是否已经存在于已上传的列表中
            // const isDuplicate = this.uniqueArr.some(uploadedFile => uploadedFile.name === file.name);
            // if (isDuplicate) {
            //   Toast({message: '该图片已经上传过了', position: 'middle', duration: 2000});
            //   return false; // 阻止上传
            // } else {
        // --------------------原版上传图片位置----------------
          //     const fileData = new FormData();
          //     fileData.append('files',file)
          //     fileData.append('imgId',file.uid)
          //     //请求接口
          //     axios.post(this.url,fileData)
          //     .then(response=>{
          //       if(response.data.msg=='操作成功'){
          //         //重写内层imgList对象数据
          //         const item = {
          //           uid:response.data.uid,
          //           name:response.data.newFileNames,
          //           url:response.data.fileNames
          //         }
          //         //添加重新对象到数组
          //         // this.arr.push(item)
          //         const arr = new Array()
          //         arr.push(item)
          //         //数组对象去重
          //         // this.uniqueArr = Array.from(new Set(this.arr.map(item => item.name)))
          //         // .map(name => this.arr.find(item => item.name === name));
          //         //外层对象
          //         const listItem = {
          //           id:this.$store.state.teacherschools.index,
          //           imgList:arr
          //         }
          //         //把生成的对象给封装方法存储
          //         studentImageList(listItem)
          //         Toast({message: '上传成功！', position: 'middle', duration: 2000});
          //       }
          //     }).catch(error=>{
                  
          //     })
          // -------------------------------------------------
              return isLt2M && isOKType;
              
          // }
      },
      handleRemove(file, fileList) {
        //直接在当前页面删除，就需要先取出上传成功封装好的数据，进行对比uid删除，删除对应的uid数据
        //删除对应所选uid的数据
        for( var k = list.length-1; k>=0;k--){ //先获取list的数组长度当作它自己的下标索引
          for (var i = list[k].imgList.length - 1; i >= 0; i--) {//在获取list索引下的imgList的数组长度当作它自己的索引
            if (list[k].imgList[i].uid == file.uid) { //如果当前list数组下的imgList数组其中的uid等于选中的uid
              list[k].imgList.splice(i, 1); //则对它进行删除
            }
          }
        }
        // Toast({message: '删除成功', position: 'middle', duration: 2000});
      },
      cancel () {
        //返回上一页面
        this.$router.goBack();
        
      },
      submits () {
        // 使用 Array.prototype.some() 方法进行查询 判断图片列表里有没有新上传的照片
        const hasRawProperty = this.fileList.some(item => item.hasOwnProperty('raw'));
          if(hasRawProperty){ //如果有，则进行上传
            this.fileList.forEach(el =>{
              if(el.raw){ //过滤掉原有的旧照片，只上传新添加的照片
                const fileData = new FormData();
                fileData.append('files',el.raw)
                fileData.append('imgId',el.raw.uid)
                //请求接口
                axios.post(this.url,fileData)
                .then(response=>{
                  if(response.data.msg=='操作成功'){
                    //如果上传了多张图片，检索成功数据，通过js分割字符串，以数组存储
                    var arr = new Array()
                    var uid = response.data.uid.split(','); //uid
                    var name = response.data.newFileNames.split(','); //newFileNames
                    var url = response.data.fileNames.split(','); //newFileNames
                    var item = {};//重写的对象（容器）
                    if(uid.length>1){
                      for (let i = 0; i < uid.length; i++) {
                        //重写内层imgList对象数据
                        item = {
                          uid:uid[i],
                          name:name[i],
                          url:url[i]
                        }
                        arr.push(item)
                      }
                    }else{
                        //重写内层imgList对象数据
                        item = {
                          uid:response.data.uid,
                          name:response.data.newFileNames,
                          url:response.data.fileNames
                        }
                        arr.push(item)
                    }
                    //添加重新对象到数组
                    //外层对象
                    const listItem = {
                      id:this.$store.state.teacherschools.index,
                      imgList:arr
                    }
                    //把生成的对象给封装方法存储
                    studentImageList(listItem)
                    Toast({message: '上传成功！', position: 'middle', duration: 2000});
                  }
                }).catch(error=>{
                    
                })
              }
            });
          }else{
            Toast({message: '请上传新的照片！', position: 'middle', duration: 2000});
          }
        // })
      
      },
      
      },
      computed:{
        ...mapGetters({
          studentList:'studentList'
        }),
      },
      watch:{
      },
      
    };
  </script>
  
  <style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "../assets/scss/base.scss";
  
    $commonWhite: #fff5d7;
    $topColor: #e6c590;
    $bottomColor: #ddb375;
  
    .base-bg {
      width: 100%;
      @include bg-img('../assets/img/common/Bg');
      .nav-bar {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: px2rem(174);
        .btn-wrapper {
          margin-left:px2rem(55);
          padding-top: px2rem(86);
          text-align: center;
        }
      }
  
      .content-block {
        margin: 0 px2rem(28);
        height: px2rem(1004);
        width: px2rem(704);
        padding: px2rem(58) px2rem(55) 0 px2rem(55);
        box-sizing: border-box;
        @include bg-img('../assets/img/common/parentbgbase');
  
        .desc-block {
          color: white;
          p {
            font-family: 'SXSLST';
            font-size: px2rem(28);
            @include text-shadow(1, 1, rgba(159, 99, 34, 0.7));
            margin-bottom: px2rem(10);
          }
  
        }
  
        .img-block {
          margin-top: px2rem(35);
  
          .images {
            height: 100%;
            margin-top: px2rem(10);
            .upload-demo{
                height: px2rem(700);
                // max-height: px2rem(700);
                overflow-y: auto;
                overflow-x: hidden;
              -webkit-overflow-scrolling: touch;
            }
            .btn-wrapper2{
              margin-top: px2rem(10);
              text-align: center;
            }
          }
  
        }
      }
    }
  
  </style>
  


// WEBPACK FOOTER //
// UpImage.vue?216d4dcf